import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private _loading = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this._loading.asObservable();

  show() {
    // HttpConfigInterceptor вызывает show()/hide() синхронно из intercept()/tap().
    // Если в этот момент Angular ещё в середине текущего change detection прохода
    // (например, дочерний компонент вроде app-pdf-generate успевает запустить свой
    // HTTP-запрос из ngOnInit прямо во время CD-прохода родителя), синхронный next()
    // меняет значение isLoading|async в AppComponent между основным проходом и
    // checkNoChanges — NG0100. Promise.resolve().then() откладывает эмиссию до конца
    // текущего синхронного CD-прохода, вместо него запускается отдельный новый тик.
    Promise.resolve().then(() => this._loading.next(true));
  }

  hide() {
    Promise.resolve().then(() => this._loading.next(false));
  }
}
